import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number = 25, trailingText: string = ''): string {
    if (!value || typeof value !== 'string') {
      return value;
    }
    let text = value.slice(0, limit);
    if (value.length > limit) {
      text = `${text}${trailingText}`;
    }

    return text;
  }
}
